import React, { useState } from 'react';
import { RiMenu3Line, RiCloseLine } from 'react-icons/ri';
import logo from '../../logo.svg';
import './navbar.css';

const Navbar = () => {
  const [toggleMenu, setToggleMenu] = useState(false);

  return (
    <div className="ain__navbar">
      <div className="ain__navbar-links">
        <div className="ain__navbar-links_logo">
          <img src={logo} />
        </div>
        <div className="ain__navbar-links_container">
          <p><a href="#home">Home</a></p>
          <p><a href="#whatain">About ALL-IN NFTs</a></p>
          <p><a href="#blog">Projects</a></p>
          <p><a href="https://medium.com/all-in-nfts">Blog</a></p>
        </div>
      </div>
      <div className="ain__navbar-sign button">
        <p><a href="https://dapp.all-in-nfts.com">Go to DApp</a></p>
      </div>
      <div className="ain__navbar-menu">
        {toggleMenu
          ? <RiCloseLine color="#fff" size={27} onClick={() => setToggleMenu(false)} />
          : <RiMenu3Line color="#fff" size={27} onClick={() => setToggleMenu(true)} />}
        {toggleMenu && (
        <div className="ain__navbar-menu_container scale-up-center">
          <div className="ain__navbar-menu_container-links">
            <p><a href="#home">Home</a></p>
            <p><a href="#whatain">About ALL-IN NFTs</a></p>
            <p><a href="#possibility">Projects</a></p>
            <p><a href="https://medium.com/all-in-nfts">Blog</a></p>
          </div>
          <div className="ain__navbar-menu_container-links-sign">
            <p><a href="https://dapp.all-in-nfts.com">Go to DApp</a></p>
          </div>
        </div>
        )}
      </div>
    </div>
  );
};

export default Navbar;
